import { Switch, withRouter } from "react-router-dom";
import Nav from "./Containers/Nav";
import CommandPalette from "./Components/CommandPalette.jsx";
import ShortcutsSheet from "./Components/ShortcutsSheet.jsx";
import OfflineBanner from "./Components/OfflineBanner.jsx";
import { SessionExpiryDialog } from "./Components/SessionExpiry.jsx";
import useUser from "./Util/useUser";
import { useSelector } from "react-redux";
import { clearPermissions } from "./features/permissions/permissionSlice.js";
import { store } from "./App/store.js";
import { logout } from "./features/auth/authSlice.js";
import { RoutesTree, createRoutesElement } from "./Components/RoutesTree.jsx";
import useProactiveRefresh from "./hooks/useProactiveRefresh.js";
import usePageTracking from "./hooks/usePageTracking.js";

const BrowserRoutes = () => {
    let { user, isLoggedIn } = useUser(useSelector);
    if (!user) user = {};

    // Keep the in-memory access token fresh and mint one right after reload,
    // so protected calls don't have to 401-then-refresh.
    useProactiveRefresh();

    // Usage analytics: one page view per route change (signed-in users only).
    usePageTracking(!!isLoggedIn);

    const logoutFunction = () => {
        store.dispatch(logout());
        store.dispatch(clearPermissions());
        window.location.reload();
    };

    return (
        <div>
            {/* Keyboard / screen-reader users jump past ~200 menu links */}
            <a href="#main" className="skip-link">Skip to content</a>
            <Nav loggedIn={isLoggedIn} logout={logoutFunction} />
            <OfflineBanner />
            {isLoggedIn && <CommandPalette />}
            {isLoggedIn && <ShortcutsSheet />}
            {isLoggedIn && <SessionExpiryDialog onSignInAgain={logoutFunction} />}
            <main id="main" tabIndex={-1}>
                <RoutesTree />
            </main>
        </div>
    );
};

export default withRouter(BrowserRoutes);
